import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: "root"
})
export class CacheService  {
  private missingHelpLinks: string[] = [];
  constructor(private http: HttpClient) {

  }


  public cacheMissingHelpLink(workflowCode: string):void {
    if (this.missingHelpLinks.indexOf(workflowCode) === -1) {
      this.missingHelpLinks.push(workflowCode);
    }
  }

  public isMissingHelpLink(workflowCode: string) {
    if (this.missingHelpLinks.indexOf(workflowCode) === -1) {
      return false;
    }
    return true;
  }

}
